import { render, staticRenderFns } from "./ModelSymptomCategory.vue?vue&type=template&id=08b3099f&scoped=true"
import script from "./ModelSymptomCategory.vue?vue&type=script&lang=js"
export * from "./ModelSymptomCategory.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "08b3099f",
  null
  
)

export default component.exports